import { Box, Chip, Grid, IconButton, Stack, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import React, { useEffect, useState } from "react";
import firstyear_pdf from "../../assets/pdfs/academic/syllabus/FirstYear.pdf";
import competency_based_syllabus from "../../assets/pdfs/academic/syllabus/competency_Based_Entry_Level_Physiotherapy.pdf";
import BPTh_syllabus_pdf from "../../assets/pdfs/academic/syllabus/BPTh_syllabus.pdf";
import MPT_syllabus_pdf from "../../assets/pdfs/academic/syllabus/MPT_SYLLABUS.pdf";

type Props = {};

interface AcademicYear {
  yearName: string;
  syllabusLink: string;
}

interface Department {
  DepartmentName: string;
  syllabusLink: string;
}

interface Course {
  courseName: string;
  academicYear?: AcademicYear[];
  Departments?: Department[];
}

const courseList: Array<Course> = [
  {
    courseName: "B.P.T. - (Bachelor’s of Physiotherapy)",
    academicYear: [
      // {
      //   yearName: "First YEAR",
      //   syllabusLink: firstyear_pdf,
      // },
      // {
      //   yearName: "Second YEAR",
      //   syllabusLink:
      //     "https://www.muhs.ac.in/upload/syllabus/Bpth_II_Year_Amended_180609_17082012_1506.pdf",
      //   },
      //   {
      //     yearName: "Third YEAR",
      //     syllabusLink:
      //     "https://www.muhs.ac.in/upload/syllabus/Bpth_III_Year_Amended_180609_17082012_1506.pdf",
      //   },
      //   {
      //     yearName: "Fourth YEAR",
      //     syllabusLink:
      //     "https://www.muhs.ac.in/upload/syllabus/Bpth_IV_Year_Amended_180609_17082012_1507.pdf",
      //   },
        {
          yearName: "competency based syllabus",
          syllabusLink: competency_based_syllabus,
        },
        {
          yearName: "B.P.Th.",
          syllabusLink: BPTh_syllabus_pdf,
        },
      ],
    },
    {
      courseName: "M.P.T. - (Master’s of Physiotherapy)",
      Departments: [
      {
        DepartmentName: "MPT SYLLABUS",
        syllabusLink: MPT_syllabus_pdf,
      },
      // {
      //   DepartmentName: "Musculoskeletal Physiotherapy",
      //   syllabusLink:
      //     "https://www.muhs.ac.in/upload/syllabus/Final%20syllabus%20of%20MPT%20200919.pdf",
      // },
      // {
      //   DepartmentName: "Neuro Physiotherapy",
      //   syllabusLink:
      //     "https://www.muhs.ac.in/upload/syllabus/Final%20syllabus%20of%20MPT%20200919.pdf",
      // },
      // {
      //   DepartmentName: "Cardiovascular and Respiratory Physiotherapy",
      //   syllabusLink:
      //     "https://www.muhs.ac.in/upload/syllabus/Final%20syllabus%20of%20MPT%20200919.pdf",
      // },
      // {
      //   DepartmentName: "Community Physiotherapy",
      //   syllabusLink:
      //     "https://www.muhs.ac.in/upload/syllabus/Final%20syllabus%20of%20MPT%20200919.pdf",
      // },
    ],
  },
];

const Syllabus = (props: Props) => {
  const [selectedCourse, setSelectedCourse] = useState<string | "">(
    "B.P.T. - (Bachelor’s of Physiotherapy)"
  );
  const [selectedSubTab, setSelectedSubTab] = useState<string | "">("");

  const handleYearClick = (year: string) => {
    if (selectedCourse === year) {
      setSelectedCourse("");
    } else {
      setSelectedCourse(year);
    }
  };

  function Subtabs(tabDetails: { subTabName: string; syllabusLink: string }) {
    return (
      <Grid item key={tabDetails?.subTabName} xs="auto" sx={{ my: 1 }}>
        <a href={tabDetails.syllabusLink} target="_blank">
          <Chip
            label={tabDetails?.subTabName}
            variant="filled"
            sx={{
              color:
                tabDetails?.subTabName === selectedSubTab
                  ? "secondary.main"
                  : "white",
              backgroundColor:
                tabDetails?.subTabName === selectedSubTab
                  ? "transparent"
                  : "secondary.main",
              cursor: "pointer",
              border: "2px solid",
              padding: "8px 16px",
              borderRadius: "16px",
              textTransform: "uppercase",
              fontSize: 14,
              fontWeight: "bold",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                opacity: 0.8,
                color: "inherit",
                backgroundColor: "transparent",
                border: "2px solid",
                borderColor: "secondary.main",
                "& .MuiChip-label": {
                  textDecoration: "underline",
                },
              },
              "&:active": {
                transform: "scale(0.95)",
              },
            }}
          />
        </a>
      </Grid>
    );
  }

  return (
    <>
      <Box
        sx={{
          backgroundColor: "primary.light",
          p: { xs: 1, md: 3 },
          width: "90vw",
        }}
        m={2}
      >
        <Stack
          direction="column"
          alignItems="flex-start"
          justifyContent="center"
          sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
          spacing={2}
        >
          {courseList?.map((item, idx) => {
            const isBPTCourse: Boolean = item.courseName.startsWith("B.P.T.");
            const subOptions: Array<AcademicYear | Department> = isBPTCourse
              ? item.academicYear || []
              : item.Departments || [];
            return (
              <Box key={idx} sx={{ width: "100%" }}>
                <Grid container alignItems={"center"}>
                  <Grid
                    sx={{
                      fontSize: 24,
                      transform: `rotate(${
                        item.courseName === selectedCourse ? 90 : 0
                      }deg)`,
                    }}
                  >
                    <ArrowForwardIosIcon />
                  </Grid>
                  <Grid>
                    <Typography
                      onClick={() => handleYearClick(item.courseName)}
                      sx={{
                        display: "block",
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: 16,
                        textDecoration: "none",
                        "&:hover": {
                          textDecoration: "underline",
                          color: "primary.main",
                        },
                        ml: 1,
                      }}
                    >
                      {item.courseName}
                    </Typography>
                  </Grid>
                </Grid>
                {selectedCourse === item.courseName &&
                  Number(subOptions?.length) > 0 && (
                    <Stack direction="column" sx={{ pl: 3 }}>
                      <Grid container spacing={2} marginY={4}>
                        {subOptions?.map((subtab, subIdx) => {
                          const tabData = {
                            subTabName: Object.values(subtab)[0] as string,
                            syllabusLink: subtab.syllabusLink,
                          };
                          return (
                            <React.Fragment key={subIdx}>
                              {Subtabs(tabData)}
                            </React.Fragment>
                          );
                        })}
                      </Grid>
                    </Stack>
                  )}
              </Box>
            );
          })}
        </Stack>
      </Box>
    </>
  );
};

export default Syllabus;
